export default __webpack_public_path__ + "static/media/users.1962753c.svg";